<template>
  <div class="billing-address group -flex -between">
    <address>
      {{ threeDSecureBillingAddress.locality }}
      {{ threeDSecureBillingAddress.region }}
      {{ threeDSecureBillingAddress.postalCode }}
      {{ threeDSecureBillingAddress.countryCodeAlpha2 }}
    </address>
    <button type="button" class="btn -anchor-link -top" @click="$emit('billing-back-action')">
      Edit
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * Read only billing address with back link.
 *
 * Assumes billing address is in 3d secure format already
 *
 * Emits the following events
 * - billing-back-action
 */
export default defineComponent({
  name: 'BillingAddressReview',
  props: {
    /**
     * @see https://braintree.github.io/braintree-web/current/ThreeDSecure.html#~billingAddress
     */
    threeDSecureBillingAddress: {
      type: Object as any,
      required: true,
    },
  },
  emits: ['billing-back-action'],
})
</script>
